<script>
import Layout from '@layouts/main.vue'
import analyticsService from '@utils/analytics-service'
import { StripeCheckout } from 'vue-stripe-checkout'

export default {
  page: {
    title: 'App Checkout',
    meta: [{ name: 'description', content: 'The App Checkout page.' }],
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    }
  },
  components: { Layout, StripeCheckout },
  data() {
    return {
      publishableKey: 'pk_live_51I4oYSLdLmXu8X2rcsxzvhdvSueVjQ2AJeZDUph0W577EINndHRz28SX4dtQvUu0DYoncBd6JMhUKko3WnsUuSYV00jN6CvzQq',
      checkoutError: null
    }
  },
  mounted() {
    analyticsService.trackPageView('App Checkout')
    try {
      this.$refs.sessionRef.redirectToCheckout()
    } catch (err) {
      this.checkoutError =
          'Something went wrong initiating checkout. Brave has a known issue here. Please try Chrome or Safari.'
    }
  },
  methods: {
    onStripeError(e) {
      this.checkoutError = e.toString()
    },
  }
}
</script>

<template>
  <Layout>
    <StripeCheckout
        ref="sessionRef"
        :pk="publishableKey"
        :session-id="sessionId"
        @error="onStripeError"
    >
    </StripeCheckout>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>

